import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";

const BussinessInsurance = () => {

  return (
    <>
    <Helmet>
    <title>Bussiness Insurance</title>
    </Helmet>
      <main className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2 flex flex-col-reverse lg:flex-row-reverse gap-6">
        {/* ====================================
                        Sticky section 
        ===================================== */}
        <section>
          <div className="md:w-96 lg:w-64 bg-blue p-6 lg:p-4  rounded-lg sw-one sticky top-36 mx-auto">
            <h2 className="text-xl font-bold text-white text-center">
              Get Project Estimation
            </h2>
            <form className="mt-6 lg:mt-3">
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white"
                type="text"
                placeholder="Name"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4"
                type="email"
                placeholder="Email"
              />
              <input
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white "
                type="number"
                placeholder="Phone number"
              />
              <select className=" outline-none px-2 rounded py-1.5 lg:py-0.5 w-full bg-white my-4">
                <option disabled="" selected="">
                  Select Budget
                </option>
                <option>USD 2000 - USD 5000</option>
                <option>USD 5000 - USD 10000</option>
                <option>USD 10000 - USD 20000</option>
                <option>USD 20000 - USD 40000</option>
                <option>USD 40000 - USD 60000</option>
                <option>USD 60000 - USD 90000</option>
                <option>USD 90000 - USD 130000</option>
                <option>USD 130000 - USD 200000</option>
                &gt;
              </select>
              <textarea
                className="outline-none px-2 rounded py-1.5 lg:py-0.5 w-full"
                placeholder="message"
                rows={3}
                defaultValue={""}
              />
              <button className="text-white bg-black px-6 mt-2 py-2 lg:py-1 rounded-md w-full font-medium">
                Submit
              </button>
            </form>
          </div>
        </section>
        {/* ====================================
                        Main section 
        ===================================== */}
        <section>
          {/* ====================================
                        Hero section
        ===================================== */}
          <section className="grid grid-span-1 lg:grid-cols-2 mt-6 lg:mt-12 gap-4 mb-16 lg:mb-32 items-center">
            <div className="">
              <img className="rounded-md" src="image/business-insurance.jpg" alt="" />
            </div>
            <div className="">
              <div className="border border-blue p-8 rounded-xl">
                <div className="flex gap-8 items-center">
                  <i className="fa-solid fa-shop text-4xl lg:text-6xl" />
                  <h2 className="font-black text-2xl md:text-3xl">
                    Business Insurance Coverage in Minutes
                  </h2>
                </div>
                <p className="my-4 font-medium text-center">
                  Get personalized Business Insurance in just a few clicks.
                </p>
                <button className="py-2 rounded-md hover:bg-blue_two duration-300 active:scale-95 w-full bg-blue font-bold text-white text-xl">
                  Get Quote Today
                </button>
              </div>
              <p className="text-2xl md:text-3xl mt-5 text-center font-bold">
                Choose the best business Insurance Plan for business
              </p>
            </div>
          </section>
          {/* ====================================
                        Text section
        ===================================== */}
          <section className=" mb-6 lg:mb-0">
            <div className="text-lg font-medium text-gray-700 text-justify">
              <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                What is business insurance?
              </h2>
              <p className="my-6">
                Business insurance protects you from the unexpected costs of running a
                business. Accidents, natural disasters, and lawsuits could run you out
                of business if you’re not protected with the right insurance. Whether
                you're operating in bustling cities like Dubai, Abu Dhabi, United Arab
                Emirates, Umm Al Quwain, or Sharjah, or in quieter areas like Al Ain
                or Ajman, having adequate insurance coverage is crucial to
                safeguarding your business interests in the UAE, including locations
                such as Ras Al Khaimah, Fujairah, and Umm Al Quwain.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-14">
              <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                Pick the type of business insurance you need
              </h2>
              <p className="my-6">
                The protections you get from choosing a business insurance can fill in
                the gaps to make sure both your personal assets and your business
                assets are fully protected from unexpected catastrophes. In some
                instances, you might be legally required to purchase certain types of
                business insurance. The federal government requires every business
                with employees to have workers’ compensation, unemployment, and
                disability insurance. Some states also require additional insurance.
                Laws requiring insurance vary by state, so visit your state’s website
                to find out the requirements for your business in places like Dubai,
                Abu Dhabi, or Sharjah, as well as other locations across the UAE such
                as Al Ain, Ajman, Ras Al Khaimah, Fujairah, and Umm Al Quwain.
              </p>
            </div>
            <div className="text-lg font-medium text-gray-700 text-justify mt-14">
              <h2 className="text-3xl md:text-4xl text-start font-bold text-black">
                Four steps to buy business insurance
              </h2>
              <ul className="list-decimal ps-5 leading-10 mt-4">
                <li>
                  Assess your risks. Think about what kind of accidents, natural
                  disasters, or lawsuits could damage your business. For example, if
                  your business is located in a commercial area that is at risk from
                  seasonal events such as fire or hail storms, commercial property
                  insurance will help protect against loss.
                </li>
                <li>
                  Find a reputable licensed agent. Commercial insurance agents can
                  help you find policies that match your business needs. They receive
                  commissions from insurance companies when they sell policies, so
                  it's important to find a licensed agent that’s interested in your
                  needs as much as his or her own.
                </li>
                <li>
                  Shop around. Prices and benefits can vary significantly. You should
                  compare rates, terms, and benefits for insurance offers from several
                  different agents.
                </li>
                <li>
                  Re-assess every year. As your business grows, so do your
                  liabilities. If you have purchased or replaced equipment or expanded
                  operations, you should contact your insurance agent to discuss
                  changes in your business and how they affect your coverage.
                </li>
              </ul>
              <h3 className="font-bold text-2xl my-6">
                The Right Types of Insurance for Businesses
              </h3>
              <p>
                There are many types of insurance options out there that business
                owners can get. Insurance helps protect your company from different
                risks that can come up during normal operations. Choosing what
                business insurance (sometimes called commercial insurance) you need
                can seem overwhelming, but we’re here to help. <br />
                <br />
                Many business owners start with a Business Owner’s Policy (BOP) for
                their small business insurance needs. It combines three essential
                coverages:General liability insurance, Commercial property insurance,
                Business income insurance
                <br />
                <br />
                We made our BOP customizable, so you can add other business insurance
                coverages to get more protection. For example, if your business
                provides a professional service to customers, you may want to get a
                professional liability insurance policy. It can help protect your
                business from claims that it made a mistake in the professional
                services given. We know every business is different. That’s why we’re
                here to help you get the right types of business insurance.
              </p>
            </div>
          </section>
        </section>
      </main>
</>
  );
}

export default BussinessInsurance;
